import { AbstractValidator } from "./AbstractValidator";
import { IValidator } from "./IValidator";
import { AbstractControl, ValidationErrors, Validators } from "@angular/forms";

import { Yii } from "libraries/interfaces/Yii";

export class EmailArray extends AbstractValidator implements IValidator {
    public static readonly NAME: string = 'email';

    public constructor() {
        super({
            [EmailArray.NAME]: {
                when: 'touched',
                message: Yii.t('wui-shared-js', 'Vous devez saisir une adresse email valide'),
            },
        });
    }

    public validate(control: AbstractControl): ValidationErrors | null {
        if ((Array.isArray(control.value) && control.value.length === 0) ||
            !control.value) {
            return null;
        }

        const pattern: RegExp = new RegExp(
            /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );

        const errors: boolean[] = control.value.map((email: string) => !pattern.test(email));

        if(errors.find((isCorrect: boolean) => isCorrect)){
            return {email: true};
        }

        return null;

    }
}
